import React from 'react';
export function Footer() {
  return <footer className="py-8 bg-black border-t border-white/10 text-center" data-id="element-69">
      <div className="container mx-auto px-4" data-id="element-70">
        <p className="text-gray-500 text-sm mb-2" data-id="element-71">
          © {new Date().getFullYear()} Kit de Serigrafía PRO. Todos los
          derechos reservados.
        </p>
        <p className="text-gray-600 text-xs max-w-2xl mx-auto" data-id="element-72">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca comercial de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}